<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>
<p align="center" style="margin-top:20px;">
    <strong>Umowa o Dzieło</strong>
</p>
<p>
    Zawarta pomiędzy:
</p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>
  , z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, o kapitale
  zakładowym w wysokości 1 664 600,00 zł, reprezentowaną przez: <strong>{{zamawiajacy}}</strong>, zwanym/zwaną dalej <strong>Zamawiającym</strong>
</p>
<p>
  a
  <br/>
  Imię i Nazwisko: {{imieNazwisko}}
  <br/>
  zamieszkały/zamieszkała w: {{zamieszkany}}
  <br/>
  PESEL: {{pesel}}
  <br/>
  Nr rachunku bankowego: {{nrRachunku}}
  <br/>
  zwaną dalej <strong>Wykonawcą</strong>.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong>
</p>
<p>
  1. Wykonawca przyjmuje do wykonania zamówienia Zamawiającego polegające
  na przedstawianiu oferty uczestnictwa w kursach dla dzieci organizowanych
  przez Szkołę Tutore Poland, dystrybucji materiałów informacyjnych
  dostarczonych przez Zamawiającego oraz przede wszystkim do przygotowania
  bazy danych osób zainteresowanych uczestnictwem w ww. kursach, zwanego
  dalej Dziełem.
  <br/>
  2. Do wykonania Dzieła Wykonawca użyje materiałów dostarczonych przez
  Zamawiającego.
  <br/>
  3. Dzieło zostanie wykonane w sposób uzgodniony i zaakceptowany przez
  Zamawiającego.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong>
</p>
<p>
  Dzieło zostanie wykonane w terminie każdorazowo określonym podczas
  przekazywania wytycznych przez Zamawiającego poprzez wysłanie e-mail’a lub
  e-mail’i określających szczegóły wykonania Dzieła.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 3</strong>
</p>
<p>
  Wykonawca nie może powierzyć realizacji Dzieła osobom trzecim.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4</strong>
</p>
<div>
  1. Za wykonanie Dzieła Wykonawca otrzyma wynagrodzenie w wysokości określonej 
  w tabeli pokazanej niżej w paragrafie 4.7. Przedmiotem rozliczenia 
  jest każdy 1 (słownie jeden) nowy wpis, który określony jest parametrami technicznymi:
  <br/>
  a) nowy - nie istniejący w dotychczasowej bazie danych Zamawiającego na dzień zbierana wpisu, 
  <br/>
  b) czytelnie zapisany w liście roboczej dostarczonej przez Zamawiającego,
  <br/>
  c) zawierający imię i nazwisko rodzica, imię i nazwisko dziecka, numer telefonu rodzica (z którym można się skutecznie połączyć), podpis rodzica w 2 rubrykach, rodzaj usługi oraz opcjonalnie e-mail rodzica.
  <br/>
  d) możliwy do weryfikacji - jeżeli osoby wyznaczone po stronie Zleceniodawcy podejmą 10 prób połączenia i każda z nich będzie nieskuteczna, wpis uznaje się za nieprawidłowy.
  <br/>
  2. Wykonawca nie może żądać podwyższenia wynagrodzenia, jeżeli wykonał
  prace dodatkowe bez uzyskania zgody Zamawiającego.
  <br/>
  3. Zamawiający ma prawo do weryfikacji prawidłowości i dokładności
  wykonania Dzieła dostarczonego przez Wykonawcę w terminie do 30 dni od daty
  dostarczenia Dzieła.
  <br/>
  4. Wynagrodzenie jest należne Wykonawcy tylko i wyłącznie za
  prawidłowe, potwierdzone przez Zamawiającego dane określone w par. 4.1.
  <br/>
  5. Wynagrodzenie Wykonawcy będzie płatne z dołu w cyklu miesięcznym do
  15-tego każdego miesiąca za miesiąc poprzedni. W przypadku gdy
  wynagrodzenie będzie przekraczać kwotę 3000,00 zł (słownie: trzy tysiące
  złotych) netto w miesiącu, Zamawiający zastrzega sobie prawo do wypłaty
  wynagrodzenia w dwóch transzach, do 15 każdego miesiąca za miesiąc
  poprzedni oraz w drugiej transzy do ostatniego dnia roboczego tego samego
  miesiąca.
  <br/>
  6. Wynagrodzenie będzie wypłacone na numer rachunku bankowego, który
  wskaże Wykonawca w odrębnym oświadczeniu do umowy.
  <br/>
  <div v-if="['1', '2', '3'].includes(typWynagrodzenia)">
    7. Wynagrodzenie jest określone w tabeli poniżej:
    <table class="table-border" style="margin-left: 5%;">
      <tbody v-if="typWynagrodzenia === '2'">
        <template v-for="(item, index) in wynagrodzenie2">
          <tr v-bind:key="index" class="table-border">
            <td class="table-border">
              <span>{{item[0]}}</span>
            </td>
            <td class="table-border">
              <span>{{item[1]}}</span>
            </td>
          </tr>
        </template>
      </tbody>
      <tbody v-else-if="typWynagrodzenia === '3'">
        <template v-for="(item, index) in wynagrodzenie3">
          <tr v-bind:key="index" class="table-border">
            <td class="table-border">
              <span>{{item[0]}}</span>
            </td>
            <td class="table-border">
              <span>{{item[1]}}</span>
            </td>
          </tr>
        </template>
      </tbody>
      <tbody v-else>
        <template v-for="(item, index) in wynagrodzenie">
          <tr v-bind:key="index" class="table-border">
            <td class="table-border">
              <span>{{item[0]}}</span>
            </td>
            <td class="table-border">
              <span>{{item[1]}}</span>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <span v-else>7. Wynagrodzenie będzie wynosiło {{ typWynagrodzenia }} zł brutto za każdy unikalny wpis.</span>
</div>
<br>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 5</strong>
</p>
<p>
  Przed każdą wizytą wyznaczoną przez Zamawiającego w określonym miejscu i
  czasie, Wykonawca jest zobowiązany do przygotowania formularzy poprzez wypełnienie daty wizyty, imienia i nazwiska oraz szkoły i jej numeru.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 6</strong>
</p>
<p>
  Po każdej wizycie wyznaczonej przez Zamawiającego w określonym miejscu i
  czasie, Wykonawca jest zobowiązany do wypełnienia raportów z wizyty tego
  samego dnia wg wytycznych:
  <br/>
  1. Przeniesienie danych z formularzy do elektronicznego narzędzia do raportowania i wykonanie zdjęcia formularzy z danymi kontaktowymi, rodzajem usługi oraz
  podpisami opiekunów dzieci:
  <br/>
  a) Wpisanie do tabeli danych wszystkich rodziców i
  dzieci zgłaszających się do uczestnictwa w lekcjach próbnych (imię,
  nazwisko i telefon rodzica, imię, nazwisko i klasa dziecka oraz rodzaj usługi, którą są zainteresowani) podczas
  określonej wizyty w szkole.
  <br/>
  b) Wykonanie czytelnych zdjęć oryginalnych formularzy z akcji
  promocyjnej.
  <br/>
  c) Wysłanie wypełnionej tabeli oraz załączonych zdjęć formularzy z akcji promocyjnej poprzez przygotowany przez Zamawiającego link do raportowania najpóźniej 24 godziny po dniu wyznaczonej wizyty w danej szkole.
  <br/>
  2. Za każdym razem Zamawiający określi tryb, w jakim dane mają być
  dostarczone przez Wykonawcę.
  <br/>
  3. Raporty sporządzone w trakcie akcji promocyjnej należy przechowywać
  w bezpiecznym miejscu, z dala od wglądu przez osoby trzecie. Po upłynięciu
  30 dni od zrealizowania dzieła, wykonawca zobowiązuje się zniszczyć, w
  sposób uniemożliwiający odczytanie, formularze z zebranymi danymi osobowymi
  od rodziców. Nie wywiązanie się z obowiązku zniszczenia dokumentów w
  wyznaczonym terminie skutkuje personalnym przejęciem pełnej
  odpowiedzialności za te dane zgodnie z ustawą z dnia 10 maja 2018 r. o
  ochronie danych osobowych, tj. Dz.U. 2018 poz. 1000 z późn. zm. oraz
  rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 7</strong>
</p>
<p>
  1. Strony zakładają staranne wykonanie umowy oraz terminowe przesyłanie raportów. 
  W razie zwłoki w wysłaniu raportu z wykonania dzieła Wykonawca zapłaci Zamawiającemu 
  karę umowną w wysokości 20 % wysokości należnego Wykonawcy wynagrodzenia za każdy 1 dzień zwłoki. 
  W przypadku spóźnienia z przesłaniem raportu lub raportów Zamawiający może przesunąć wypłacenie wynagrodzenia 
  za wykonanie dzieła na miesiąc następny.
  <br/>
  2. W razie gdy zwłoka w wykonaniu dzieła przekroczy 3 dni, Zamawiający może od
  umowy odstąpić z zachowaniem prawa do kar umownych i odszkodowania.
</p>
<p>
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 8</strong>
</p>
<p>
  W przypadku potwierdzenia dyspozycyjności przez Wykonawcę, Zamawiający
  zobowiązuje się do przydzielenia akcji najpóźniej do godz. 17.00 dnia
  poprzedzającego akcję. Wykonawca w takim przypadku ma obowiązek
  uczestniczyć w wykonaniu zlecenia. Za niestawienie się w wyznaczonym
  miejscu przez Wykonawcę, Zamawiający może naliczyć karę umowną w wysokości
  300 zł, która może być rozliczona z wynagrodzenia należnego Wykonawcy.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 9</strong>
</p>
<p>
  Zamawiający może odstąpić od umowy w przypadku gdy Wykonawca zrezygnuje z
  więcej niż trzech akcji promocyjnych w trakcie, których Wykonawca jest
  zobowiązanych do realizacji dzieła.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 10</strong>
</p>
<p>
  W sprawach nieuregulowanych niniejszą umową mają zastosowanie przepisy
  Kodeksu cywilnego.
</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 11</strong>
</p>
<p>
  Umowę sporządzono w dwóch jednobrzmiących egzemplarzach po jednym dla
  każdej ze stron.
</p>
<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        {{zamawiajacy}}<br>
        <span style="margin-left: 15%;">(Zamawiający)</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 15%;">(Wykonawca)</span>
    </div>
</div>
<div v-if="!bezOswiadczenia" style="margin-top: 10px;page-break-before: always;">
<p style="margin-bottom: 2px;" align="right">Dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}}</p>
<p style="margin-bottom: 2px;" align="center" class="subheading"><strong>Oświadczenie do umowy o dzieło</strong></p>
<p style="margin-bottom: 2px;"><strong>Imiona i Nazwisko </strong><span>{{imieNazwisko}}</span></p>
<p style="margin-bottom: 2px;"><strong>PESEL </strong><span>{{pesel}}</span></p>
<p style="margin-bottom: 2px;"><strong>Seria i Nr dowodu osobistego </strong><span>{{nrDowodu}}</span></p>
<p style="margin-bottom: 2px;"><strong>Nr telefonu </strong><span>{{nrTelefonu}}</span></p>
<p style="margin-bottom: 2px;"><strong>E-Mail </strong><span>{{email}}</span></p>
<p style="margin-bottom: 2px;"><strong>Adres Zamieszkania </strong><span>{{zamieszkany}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>

<p style="margin-bottom: 2px;"><strong>Adres Korespondencyjny </strong><span>{{korespondencyjny}}</span><br>
<span class="caption">(ulica, nr domu, kod pocztowy, miejscowość)</span></p>

<p style="margin-bottom: 2px;"><strong>Urząd Skarbowy </strong><span>{{urzadSkarbowy}}</span><br>
<span class="caption">(właściwy do przekazania rocznej informacji o dochodach i pobranych zaliczkach na podatek dochodowy)</span></p>
<p style="margin-bottom: 2px;"><strong>Moim identyfikatorem podatkowym</strong><span> jest: </span>
<span v-if="nip === ''">PESEL</span>
<span v-else>NIP {{nip}}</span></p>
<p style="margin-bottom: 10px;"><strong>Nr rachunku bankowego </strong><span>{{nrRachunku}}</span></p>
<p style="margin-bottom: 2px; font-size: x-small;"><span>Oświadczam, że dane zawarte w formularzu są zgodne ze stanem prawnym i faktycznym. Jestem świadoma/y odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy. Zobowiązuję się do poinformowania Zleceniodawcy</span><strong> w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany.</strong></p>
<p style="font-size: x-small;">Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji.</p>
<p style="margin-bottom: 2px; font-size: x-small;"><strong>INFORMACJA:</strong></p>
<p style="margin-bottom: 2px; font-size: x-small;"><span>Numer NIP jest identyfikatorem podatkowym w przypadku podmiot&oacute;w (podatnik&oacute;w) podlegających obowiązkowi ewidencyjnemu na podstawie odrębnych ustaw oraz płatnik&oacute;w podatk&oacute;w w szczeg&oacute;lności:</span></p>
<ul style="font-size: x-small;">
<li><span>prowadzących działalność gospodarczą</span></li>
<li><span>płatnik&oacute;w </span> <span>podatku od towar&oacute;w i usług (VAT)</span></li>
<li><span>płatnik&oacute;w </span> <span>składek na ubezpieczenie społeczne i zdrowotne</span></li>
<li><span>płatnik&oacute;w </span> <span>podatku z najmu i dzierżawy</span></li>
</ul>
</div>
<div v-if="!bezOswiadczenia" style="margin-top: 15px;">
<p style="margin-bottom: 10px;" align="center" class="subheading"><strong>Informacja o ochronie danych osobowych </strong></p>
<p style="margin-bottom: 10px; font-size: small;"><span>
  Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 
  z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku 
  z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE og&oacute;lne rozporządzenie o ochronie danych, 
  (&bdquo;Rozporządzenie&rdquo;) informujemy, że Administratorem Danych Osobowych jest: 
</span></p>
<p style="margin-bottom: 10px; font-size: small;"><em>
  <span>
    Tutore Poland Sp. z o.o. z siedzibą w Łodzi przy 
    ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
    wpisana do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
    sąd rejestrowy dla Łodzi Śr&oacute;dmieścia, XX Wydział Krajowego Rejestru Sądowego, 
    NIP: 7272812193.
  </span>
</em></p>
<p style="margin-bottom: 10px; font-size: small;">
  <span>
    Kontakt z Administratorem Danych Osobowych możesz uzyskać pisemnie, 
    kierując korespondencję na powyższy adres lub elektronicznie, korzystając z adresu e-mail: 
  </span>
  <a href="mailto:kadry@szkolam.pl"><span>kadry@szkolamm.pl</span></a>
</p>
<p style="margin-bottom: 10px; font-size: small;"><span>
  Dane osobowe są przetwarzane w celu zawarcia i realizacji zawartej umowy, 
  tj. na podstawie art. 6 ust. 1 lit. b &nbsp;Rozporządzenia. 
  Podanie danych jest dobrowolne, jednak konieczne w celu zawarcia i wykonania Umowy. 
  W związku z realizacją usług dane osobowe zostaną przekazane podmiotom zewnętrznym, 
  w tym w szczeg&oacute;lności dostawcom system&oacute;w i usług informatycznych, 
  bankom i operatorom płatności, podmiotom świadczącym usługi księgowe,prawne, audytowe, 
  konsultingowe, kurierom, oraz podmiotom powiązanym z Administratorem, 
  kt&oacute;rzy zajmują się realizacją zam&oacute;wień. Dane osobowe będą przechowywane 
  przez okres trwania umowy, a po jej zakończeniu przez czas wynikający z obowiązujących 
  przepis&oacute;w prawa lub do czasu przedawnienia wzajemnych roszczeń. Każda osoba, 
  kt&oacute;rej dane dotyczą ma prawo dostępu do swoich danych osobowych, żądania 
  ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu 
  wobec przetwarzania danych oraz prawo do przenoszenia danych. 
  W celu realizacji powyższych uprawnień należy skontaktować się 
  z Administratorem Danych Osobowych, korzystając z danych teleadresowych, 
  wskazanych powyżej. Osoba, kt&oacute;rej dane dotyczą ma także prawo wniesienia skargi 
  do organu nadzorczego, gdy uzna, iż przetwarzanie danych osobowych narusza przepisy prawa.
  </span></p>
</div>
<div v-if="!bezOswiadczenia" style="margin-top: 40px; page-break-before: always;">

<p align="center"><strong>Umowa powierzenia przetwarzania danych osobowych</strong></p>
<p>&nbsp;</p>
<p><span>(zwana dalej &bdquo;Umową&rdquo;) zawarta pomiędzy: </span></p>
<p><strong>Tutore Poland sp&oacute;łka z ograniczoną odpowiedzialnością </strong>
<span>
  z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Ł&oacute;dź, 
  wpisaną do rejestru przedsiębiorc&oacute;w pod numerem KRS: 0000670834, 
  sąd rejestrowy: Sąd Rejonowy dla Łodzi-Śr&oacute;dmieścia w Łodzi, XX Wydział Gospodarczy KRS, 
  NIP: 7272812193, REGON: 366891567,
</span>
</p>
<p><span>reprezentowaną przez: </span>
<strong>{{zamawiajacy}}</strong><span>, zwaną/zwanego </span>
<span>w dalszej części umowy </span><strong>&bdquo;Administratorem&rdquo;</strong></p>
<p><span>oraz</span></p>
<p><span>Imię i Nazwisko: {{imieNazwisko}}</span><br />
<span>Adres Zamieszkania: {{zamieszkany}}</span><br />
<span>PESEL: {{pesel}}</span></p>
<p>
  <span>zwanym/zwaną w dalszej części umowy </span>
  <strong>&bdquo;Podmiotem przetwarzającym&rdquo;</strong>
</p>
<p>&nbsp;</p>
<p><strong>Preambuła</strong></p>
<p><span>Zważywszy iż:</span></p>
<ul>
<li><span>
  Strony łączy umowa z dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}} 
  świadczenie usług polegających na przygotowaniu bazy danych os&oacute;b zainteresowanych usługami sp&oacute;łki 
  (zwana dalej: &bdquo;Umową podstawową&rdquo;);
</span></li>
<li><span>
  w związku z zawarciem i wykonywaniem Umowy konieczne jest powierzenie Podmiotowi przetwarzającemu 
  przez Administratora danych osobowych w trybie art.&nbsp;28 rozporządzenia Parlamentu Europejskiego 
  i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych 
  w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych 
  oraz uchylenia dyrektywy 95/46/WE (og&oacute;lnego rozporządzenia o ochronie danych) 
  (Dz.U.UE.L.2016.119.1) &ndash; zwanego dalej: &bdquo;Rozporządzeniem&rdquo;,
  </span></li>
</ul>
<p style="margin-top: 20px;"><span>Strony postanowiły zawrzeć umowę o następującej treści:</span></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§1 Powierzenie przetwarzania danych osobowych</strong>
</p>
<ol>
<li><span>Mając na uwadze treść art. art. 28 Rozporządzenia, Administrator danych powierza Podmiotowi przetwarzającemu dane osobowe do przetwarzania, na zasadach &nbsp;i w celu określonym w niniejszej umowie.</span></li>
<li><span>Zawarcie niniejszej umowy powierzenia stanowi udokumentowane polecenie Administratora do przetwarzania danych przez Podmiot przetwarzający.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się przetwarzać powierzone mu dane osobowe zgodnie z niniejszą umową, Rozporządzeniem oraz z innymi przepisami prawa powszechnie obowiązującego, kt&oacute;re chronią prawa os&oacute;b, kt&oacute;rych dane dotyczą.</span></li>
<li><span>Podmiot przetwarzający oświadcza, iż stosuje techniczne i organizacyjne środki zapewniające bezpieczeństwo danych i ochronę praw os&oacute;b, kt&oacute;rych one dotyczą oraz &nbsp;spełniające wymogi Rozporządzenia. </span></li>
</ol>
<p>&nbsp;<br><br></p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§2 Zakres i cel przetwarzania danych</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający będzie przetwarzał powierzone na podstawie niniejszej umowy następujące dane:</span></li>
</ol>
<p>&nbsp;</p>
<table style="border: 1px solid; text-align: left;">
<tbody>
<tr>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Kategorie os&oacute;b, kt&oacute;rych dotyczy przetwarzanie</span></p>
</td>
<td>
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Rodzaj danych osobowych</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Czy powierzone dane osobowe obejmują szczeg&oacute;lne kategorie danych?</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Zakres przetwarzania</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Forma przetwarzania</span></p>
</td>
</tr>
<tr>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>dane osobowe dzieci i ich rodzic&oacute;w/opiekun&oacute;w prawnych </span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Imię i nazwisko dziecka i jego rodzica, nr telefonu,e-mail.</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Nie</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>zbieranie, organizowanie, utrwalanie, porządkowanie.</span></p>
</td>
<td style="border: 1px solid;">
<p style="margin-top: 10px; margin-left: 10px; margin-right: 10px;"><span>Elektroniczna i papierowa</span></p>
</td>
</tr>
</tbody>
</table>
<p><br /><br /></p>
<ol>
<li><span>Powierzone przez Administratora dane osobowe będą przetwarzane przez Podmiot przetwarzający wyłącznie w celu wykonania Umowy podstawowej. </span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§3 Obowiązki podmiotu przetwarzającego</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający zobowiązuje się, przy przetwarzaniu powierzonych danych osobowych, do ich zabezpieczenia poprzez stosowanie odpowiednich środk&oacute;w technicznych i organizacyjnych zapewniających adekwatny stopień bezpieczeństwa odpowiadający ryzyku związanym z przetwarzaniem danych osobowych, o kt&oacute;rych mowa w art. 32 Rozporządzenia. Podmiot przetwarzający zobowiązuje się do regularnej weryfikacji i aktualizacji stosowanych przez niego środk&oacute;w technicznych i organizacyjnych tak, aby zapewnić powierzonym danym osobowym adekwatny stopień ochrony. Podmiot przetwarzający, na każde żądanie Administratora danych, przekaże informacje o stosowanych przez niego środkach organizacyjnych i technicznych związanych z przetwarzaniem danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się dołożyć należytej staranności przy przetwarzaniu powierzonych danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do nadania upoważnień do przetwarzania danych osobowych wszystkim osobom, kt&oacute;re będą przetwarzały powierzone dane w celu realizacji niniejszej umowy. </span></li>
<li><span>Podmiot przetwarzający zobowiązuje się, że osoby, kt&oacute;re będą przetwarzały w jego imieniu dane osobowe powierzone na podstawie niniejszej umowy zostaną dopuszczone do przetwarzania jedynie po odbyciu szkoleń z zakresu ochrony danych osobowych (w szczeg&oacute;lności z ochrony danych osobowych i odpowiedzialności za ochronę tych danych przed niepowołanym dostępem, nieuzasadnioną modyfikacją, zniszczeniem, nielegalnym ujawnieniem lub pozyskaniem danych osobowych). Podmiot przetwarzający oświadcza, że dostęp do danych osobowych będą miały jedynie osoby, dla kt&oacute;rych dostęp ten jest niezbędny do wykonania usług określonych w Umowie gł&oacute;wnej.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się zapewnić zachowanie powierzonych danych w tajemnicy, o kt&oacute;rej mowa w art. 28 ust 3 pkt b Rozporządzenia. W tym celu Podmiot przetwarzający &nbsp;zobowiązuje do zachowania przetwarzanych danych w tajemnicy osoby, kt&oacute;re upoważnia do przetwarzania danych osobowych w celu realizacji niniejszej umowy, zar&oacute;wno w trakcie zatrudnienia ich w Podmiocie przetwarzającym, jak i po jego ustaniu.</span></li>
<li><span>Podmiot przetwarzający po zakończeniu świadczenia usług związanych </span><span><br /></span><span>z przetwarzaniem usuwa wszelkie dane osobowe powierzone na podstawie niniejszej umowy oraz wszelkie ich istniejące kopie, chyba że prawo Unii lub prawo państwa członkowskiego nakazują przechowywanie danych osobowych.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się wsp&oacute;łpracować z Administratorem w wywiązywaniu się z obowiązku odpowiadania na żądania osoby, kt&oacute;rej dane dotyczą oraz wywiązywania się z obowiązk&oacute;w określonych w art. 32-36 Rozporządzenia. W tym celu Podmiot przetwarzający zobowiązuje się w szczeg&oacute;lności udzielać Administratorowi stosowne informacje lub przekazywać niezbędne dokumenty związane z żądaniem osoby fizycznej i przetworzonymi przez niego danymi osobowymi, nie p&oacute;źniej niż w terminie 7 dni od dnia skierowania stosownego żądania przez Administratora danych</span></li>
<li><span>Podmiot przetwarzający po stwierdzeniu naruszenia ochrony danych osobowych bez zbędnej zwłoki, jednak nie p&oacute;źniej niż w ciągu 24 godzin od chwili powzięcia wiedzy o naruszeniu, zgłasza je Administratorowi. Zgłoszenie będzie zawierać co najmniej opis okoliczności zdarzenia stanowiącego naruszenie ochrony danych osobowych oraz jego ustalonych lub podejrzewanych przyczyn; opis charakteru naruszenia ochrony danych osobowych, w tym w miarę możliwości wskazanie kategorii i przybliżonej liczby os&oacute;b, kt&oacute;rych dane osobowe dotyczą; opis możliwych konsekwencji naruszenia ochrony danych osobowych; opis zastosowanych przez Podmiot przetwarzający środk&oacute;w zaradczych w celu zminimalizowania ewentualnych negatywnych skutk&oacute;w naruszenia ochrony danych osobowych.</span></li>
<li><span>W przypadku stwierdzenia jakiejkolwiek sytuacji stanowiącej naruszenie ochrony danych osobowych lub grożącej takim naruszeniem Podmiot przetwarzający zobowiązany jest:</span></li>

<ol>
<li><span>niezwłocznie, lecz nie p&oacute;źniej niż w ciągu 24 godzin od stwierdzenia takiej sytuacji, poinformować o tym Administratora,</span></li>
<li><span>podjąć niezwłocznie wszelkie czynności mające na celu usunięcie naruszenia lub zagrożenia i zabezpieczenie danych osobowych w spos&oacute;b należyty przed dalszymi naruszeniami,</span></li>
<li><span>zebrać wszystkie możliwe dane i dokumenty, kt&oacute;re mogą pom&oacute;c w ustaleniu okoliczności naruszenia i przeciwdziałaniu podobnym sytuacjom w przyszłości,</span></li>
<li><span>udzielać Administratorowi wszelkich wyjaśnień.</span></li>
</ol>
<li><span>Podmiot przetwarzający oświadcza, że nie powołał Inspektora Ochrony Danych.</span></li>
<li><span>Podmiot przetwarzający oświadcza, że powierzone mu do przetwarzania Dane osobowe przetwarzane będą wyłącznie na terytorium Unii Europejskiej lub Europejskiego Obszaru Gospodarczego.**</span></li>

</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§4 Prawo kontroli</strong>
</p>
<ol>
<li><span>Administrator danych zgodnie z art. 28 ust. 3 pkt h) Rozporządzenia ma prawo kontroli &nbsp;&nbsp;&nbsp;i weryfikacji czy środki zastosowane przez Podmiot przetwarzający przy przetwarzaniu i zabezpieczeniu powierzonych danych osobowych spełniają postanowienia niniejszej umowy i Rozporządzenia. </span></li>
<li><span>Administrator danych realizować będzie prawo kontroli w godzinach pracy Podmiotu przetwarzającego i z minimum 3 dniowym jego uprzedzeniem.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do usunięcia uchybień stwierdzonych podczas kontroli w terminie wskazanym przez Administratora danych nie dłuższym niż 7 dni.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się wsp&oacute;łpracować z Administratorem w zakresie prowadzonej kontroli, w tym w szczeg&oacute;lności zobowiązuje się:</span></li>
<ol>
<li><span>udostępnić Administratorowi wszelkie informacje i dokumenty niezbędne do przeprowadzenia kontroli, </span></li>
<li><span>dopuścić Administratora do obszaru przetwarzania danych osobowych oraz system&oacute;w informatycznych związanych z przetwarzaniem danych osobowych,</span></li>
<li><span>zapewnić Administratorowi możliwość przeprowadzenia rozm&oacute;w z pracownikami i wsp&oacute;łpracownikami Podmiotu przetwarzającego.</span></li>
</ol>
<li><span>Administrator danych jest uprawniony do wydawania Podmiotowi przetwarzającemu wiążących poleceń odnośnie sposobu wykonania niniejszej umowy.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§5 Dalsze powierzenie danych do przetwarzania</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający może powierzyć dane osobowe objęte niniejszą umową do dalszego przetwarzania podwykonawcom jedynie w celu wykonania umowy po uzyskaniu uprzedniej pisemnej zgody Administratora danych. &nbsp;</span></li>
<li><span>Przekazanie powierzonych danych do państwa trzeciego może nastąpić jedynie na pisemne polecenie Administratora danych chyba, że obowiązek taki nakłada na Podmiot przetwarzający prawo Unii lub prawo państwa członkowskiego, kt&oacute;remu podlega Podmiot przetwarzający. W takim przypadku przed rozpoczęciem przetwarzania Podmiot przetwarzający informuje Administratora danych o tym obowiązku prawnym, o ile prawo to nie zabrania udzielania takiej informacji z uwagi na ważny interes publiczny.</span></li>
<li><span>Podwykonawca, o kt&oacute;rym mowa w &sect; 5 ust. 1 winien spełniać te same gwarancje &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;i obowiązki jakie zostały nałożone na Podmiot przetwarzający w niniejszej umowie. </span></li>
<li><span>Podmiot przetwarzający ponosi pełną odpowiedzialność wobec Administratora za niewywiązanie się ze spoczywających na podwykonawcy obowiązk&oacute;w w zakresie ochrony danych osobowych.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§6 Odpowiedzialność Podmiotu przetwarzającego</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający jest odpowiedzialny za szkody wyrządzone Administratorowi, osobie fizycznej, kt&oacute;rej dane osobowe dotyczą lub innym osobom trzecim w związku z niewykonaniem lub nienależytym wykonaniem Umowy powierzenia, polegającym w szczeg&oacute;lności na działaniu niezgodnym z treścią Umowy powierzenia &nbsp;lub Rozporządzenia.</span></li>
<li><span>Podmiot przetwarzający jest odpowiedzialny za udostępnienie lub wykorzystanie danych osobowych niezgodnie z treścią umowy, a w szczeg&oacute;lności za udostępnienie powierzonych do przetwarzania danych osobowych osobom nieupoważnionym. </span></li>
<li><span>Podmiot przetwarzający odpowiada za działania i zaniechania os&oacute;b, przy pomocy kt&oacute;rych będzie przetwarzał powierzone dane osobowe, jak za działania lub zaniechania własne.</span></li>
<li><span>Podmiot przetwarzający zobowiązuje się do niezwłocznego poinformowania Administratora danych o jakimkolwiek postępowaniu, w szczeg&oacute;lności administracyjnym lub sądowym, dotyczącym przetwarzania przez Podmiot przetwarzający danych osobowych określonych w umowie, o jakiejkolwiek decyzji administracyjnej lub orzeczeniu dotyczącym przetwarzania tych danych, skierowanych do Podmiotu przetwarzającego, a także o wszelkich planowanych, &nbsp;o ile są wiadome, lub realizowanych kontrolach i inspekcjach dotyczących przetwarzania w Podmiocie przetwarzającym tych danych osobowych. Niniejszy ustęp dotyczy wyłącznie danych osobowych powierzonych przez Administratora danych. </span></li>
<li><span>W przypadku nałożenia na Administratora prawomocnej kary za niezgodne z prawem przetwarzanie danych osobowych przez Podmiot przetwarzający lub podwykonawcę, o kt&oacute;rym mowa w &sect; 5 ust. 1 Umowy, Podmiot przetwarzający zapłaci na rzecz Administratora karę umowną w wysokości ciężaru finansowego nałożonego na Administratora.</span></li>
<li><span>W przypadku, gdy w związku z niezgodnym z niniejszą umową i przepisami Rozporządzania przetwarzaniem danych osobowych powierzonych Podmiotowi przetwarzającemu, z przyczyn leżących po stronie Podmiotu przetwarzającego (wina), Administrator poniesie jakiekolwiek koszty, w szczeg&oacute;lności związane z wypłatą zadośćuczynienia lub koszty obsługi prawnej, Podmiot przetwarzający zobowiązany będzie pokrycia tych koszt&oacute;w w pełnej wysokości, a w przypadku wytoczonego postępowania sądowego - do udzielenia Administratorowi wszelkiego wsparcia w takim postępowaniu, a także do przejęcia odpowiedzialności w przypadku przyznania osobie fizycznej odszkodowania w takim postępowaniu, w wysokości odpowiadającej r&oacute;wnowartości przyznanego odszkodowania lub koszt&oacute;w zadośćuczynienia oraz wszelkich koszt&oacute;w niezbędnych do obrony przed zgłaszanymi roszczeniami a poniesionych przez Administratora w takim postępowaniu.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§7 Czas obowiązywania umowy</strong>
</p>
<ol>
<li><span>Niniejsza umowa obowiązuje od dnia jej zawarcia przez cały &nbsp;czas obowiązywania Umowy podstawowej. </span></li>
<li><span>Podmiot przetwarzający zaprzestanie przetwarzania danych osobowych wraz z wygaśnięciem Umowy podstawowej, jak r&oacute;wnież na każde żądanie Administratora.</span></li>
<li><span>Każda ze stron może wypowiedzieć niniejszą umowę z zachowaniem 7-dniowego okresu wypowiedzenia.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§8 Rozwiązanie umowy</strong>
</p>
<ol>
<li><span>Niniejsza umowa została zawarta na czas obowiązywania Umowy podstawowej, przy czym rozwiązanie, wypowiedzenie lub wygaśnięcie Umowy podstawowej powoduje jednoczesne odpowiednio rozwiązanie, wypowiedzenie lub wygaśnięcie niniejszej umowy bez konieczności składania przez Strony dodatkowych oświadczeń w tym zakresie, chyba że Strony postanowią inaczej, z zastrzeżeniem kolejnych ustęp&oacute;w.</span></li>
<li><span>Administrator danych może rozwiązać niniejszą umowę ze skutkiem natychmiastowym, gdy Podmiot przetwarzający:</span></li>

<ol>
<li><span>pomimo zobowiązania go do usunięcia uchybień stwierdzonych podczas kontroli nie usunie ich w wyznaczonym terminie;</span></li>
<li><span>przetwarza dane osobowe w spos&oacute;b niezgodny z umową lub Rozporządzeniem;</span></li>
<li><span>powierzył przetwarzanie danych osobowych innemu podmiotowi bez zgody Administratora danych;</span></li>
</ol>

<li><span>Rozwiązanie umowy w trybie opisanym w ust. 2 powyżej następuje poprzez złożenie przez Administratora pisemnego oświadczenia Podmiotowi przetwarzającemu.</span></li>
<li><span>Strony zgodnie postanawiają, że rozwiązanie umowy powierzenia w spos&oacute;b określony w &nbsp;&nbsp;ust. 2 powyżej powoduje jednoczesne rozwiązanie Umowy podstawowej z winy Podmiotu przetwarzającego bez konieczności składania dodatkowych oświadczeń, chyba że co innego wynika z oświadczenia Administratora, o kt&oacute;rym mowa w ust. 3 powyżej.</span></li>

</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§9 Wzajemna komunikacja</strong>
</p>
<ol>
<li><span>W celu zapewnienia wzajemnej komunikacji w zakresie realizacji przedmiotu niniejszej umowy Strony wskazują poniżej do kontaktu następujące adresy poczty elektronicznej:</span></li>

<ol>
<li><span>po stronie Administratora: kadry@szkolamm.pl</span></li>
<li><span>po stronie Podmiotu przetwarzającego: {{email}}</span></li>
</ol>

<li><span>Zmiana adres&oacute;w poczty elektronicznej, o kt&oacute;rych mowa w ust. 1 nie wymaga zmiany niniejszej umowy i następuje poprzez wzajemne zawiadomienie przez Strony.</span></li>
<li><span>Strony zgodnie oświadczają, że osoby wskazane w pkt. 1 zostały poinformowane, iż administratorem ich danych osobowych jest odpowiednio Administrator lub Podmiot przetwarzający; dane osobowe będą przechowywane przez czas trwania umowy, a także po jej zakończeniu w celu wykonania obowiązk&oacute;w prawnych oraz dochodzenia wzajemnych roszczeń do czasu ich przedawnienia; odbiorcami danych są podmioty świadczące usługi archiwizacji i niszczenia dokument&oacute;w, firmy hostingowe oraz informatyczne, w tym podmioty obsługujące pocztę e-mail; mają prawo dostępu do swoich danych osobowych, żądania ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu wobec przetwarzania danych oraz prawo do przenoszenia danych, a także prawo wniesienia skargi do organu nadzorczego w przypadku przetwarzania danych osobowych naruszającego przepisy prawa.</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§10 Zasady zachowania poufności</strong>
</p>
<ol>
<li><span>Podmiot przetwarzający zobowiązuje się do zachowania w tajemnicy wszelkich informacji, danych, materiał&oacute;w, dokument&oacute;w i danych osobowych otrzymanych od Administratora danych i od wsp&oacute;łpracujących z nim os&oacute;b oraz danych uzyskanych w jakikolwiek inny spos&oacute;b, zamierzony czy przypadkowy w formie ustnej, pisemnej lub elektronicznej (&bdquo;dane poufne&rdquo;).</span></li>
<li><span>Podmiot przetwarzający oświadcza, że w związku ze zobowiązaniem do zachowania w tajemnicy danych poufnych nie będą one wykorzystywane, ujawniane ani udostępniane bez pisemnej zgody Administratora danych w innym celu niż wykonanie Umowy, chyba że konieczność ujawnienia posiadanych informacji wynika z obowiązujących przepis&oacute;w prawa lub Umowy.</span></li>
<li><span>Obowiązek zachowania w tajemnicy danych poufnych obowiązuje w czasie trwania niniejszej umowy oraz przez okres 5 lat od jej rozwiązania (bez względu na przyczynę).</span></li>
</ol>
<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§11 Postanowienia końcowe</strong>
</p>
<ol>
<li><span>Sądem właściwym dla rozpatrzenia spor&oacute;w wynikających z niniejszej umowy będzie sąd właściwy dla Administratora danych. </span></li>
<li><span>W sprawach nieuregulowanych zastosowanie będą miały przepisy Kodeksu cywilnego oraz Rozporządzenia.</span></li>
<li><span>Umowa została sporządzona w dw&oacute;ch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</span></li>
</ol>
<p><br /><br /><br /></p>


<div v-if="!bezOswiadczenia" class="cointainer" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    {{zamawiajacy}}<br>
    <span class="caption">(Administrator danych)</span>
  </div>
  <div class="right-cointainer">
    {{imieNazwisko}}<br>
    <span class="caption">(Podmiot przetwarzający)</span>
  </div>
</div>

<p><br /><br /></p>
<p v-if="!bezOswiadczenia"><span>** jeżeli podmiot przetwarzający zamierza &nbsp;przekazywać dane osobowe do państwa trzeciego, należy wskazać tę okoliczność w umowie i podać podstawę prawną przekazania</span></p>

</div>


</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaPrzedstawiciel',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nip: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      urzadSkarbowy: '',
      typWynagrodzenia: null,
      wynagrodzenie: [
        ['Wynagrodzenie brutto', 'Ilość wpisów'],
        ['50 zł', '5-7'],
        ['56 zł', '8'],
        ['63 zł', '9'],
        ['70 zł', '10'],
        ['+ 7 zł', 'za każdy kolejny wpis powyżej 10'],
        ['na przykład:'],
        ['140 zł', '20'],
        ['210 zł', '30'],
        ['280 zł', '40'],
        ['350 zł', '50'],
        ['420 zł', '60'],
        ['490 zł', '70'],
        ['560 zł', '80'],
        ['630 zł', '90'],
        ['700 zł', '100']
      ],
      wynagrodzenie2: [
        ['Wynagrodzenie brutto', 'Ilość wpisów'],
        ['30 zł', '1-4'],
        ['35 zł', '5'],
        ['42 zł', '6'],
        ['49 zł', '7'],
        ['56 zł', '8'],
        ['63 zł', '9'],
        ['70 zł', '10'],
        ['+ 7 zł', 'za każdy kolejny wpis powyżej 10'],
        ['na przykład:'],
        ['140 zł', '20'],
        ['210 zł', '30'],
        ['280 zł', '40'],
        ['350 zł', '50'],
        ['420 zł', '60'],
        ['490 zł', '70'],
        ['560 zł', '80'],
        ['630 zł', '90'],
        ['700 zł', '100']
      ],
      wynagrodzenie3: [
        ['Wynagrodzenie brutto', 'Ilość wpisów'],
        ['50 zł', '1-7'],
        ['56 zł', '8'],
        ['63 zł', '9'],
        ['70 zł', '10'],
        ['+ 7 zł', 'za każdy kolejny wpis powyżej 10'],
        ['na przykład:'],
        ['140 zł', '20'],
        ['210 zł', '30'],
        ['280 zł', '40'],
        ['350 zł', '50'],
        ['420 zł', '60'],
        ['490 zł', '70'],
        ['560 zł', '80'],
        ['630 zł', '90'],
        ['700 zł', '100']
      ],
      bezOswiadczenia: false
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaPrzedstawiciel.vue